import { render, staticRenderFns } from "./LotMapping.vue?vue&type=template&id=c987ff6e&scoped=true"
import script from "./LotMapping.vue?vue&type=script&lang=js"
export * from "./LotMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c987ff6e",
  null
  
)

export default component.exports